import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FileText, ArrowLeft } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { OTPLogin } from '@/components/auth/OTPLogin';
import { ThemeToggle } from '@/components/shared/ThemeToggle';

export default function LoginPage() {
  const navigate = useNavigate();
  const { updateUser } = useAuth();

  const navigateByRole = (role) => {
    if (role === 'admin') {
      navigate('/admin/dashboard');
    } else if (role === 'agent') {
      navigate('/agent/dashboard');
    } else if (role === 'agency') {
      navigate('/agency/dashboard');
    } else if (role === 'business') {
      navigate('/business/dashboard');
    } else {
      navigate('/dashboard');
    }
  };

  const handleLoginSuccess = (data) => {
    // Update auth context
    if (updateUser) {
      updateUser(data.user);
    }
    navigateByRole(data.user.role);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary/5 via-background to-secondary/5 p-4 relative">
      {/* Theme Toggle - Top Right */}
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>

      <div className="w-full max-w-md">
        {/* Back Button */}
        <Button 
          variant="ghost" 
          className="mb-4 text-muted-foreground hover:text-foreground"
          onClick={() => navigate('/')}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Button>

        {/* Logo */}
        <div className="mb-8 text-center">
          <img src="/logo.png" alt="Kosha Tax Logo" className="mx-auto mb-4 h-24 w-24 object-contain" />
          <h1 className="text-3xl font-bold text-foreground">Kosha Tax</h1>
          <p className="mt-2 text-sm text-muted-foreground">Precision in Every Return.</p>
        </div>

        <Card className="card-elevated shadow-material-xl">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl">Sign In</CardTitle>
            <CardDescription>
              Enter your email to sign in or create an account
            </CardDescription>
          </CardHeader>
          <CardContent>
            <OTPLogin onSuccess={handleLoginSuccess} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
